function getComplianceBadge(badgeType, badgeCode) {
  let icon;
  if (badgeType === "50 State Compliant") {
    icon = getFiftyStateBadge();
  } else if (badgeType === "49 State Compliant") {
    if (badgeCode === "California Compliance in Progress") {
      icon = getFortyNineStateBadge();
    } else if (badgeCode === "Not for sale in California") {
      icon = getFortyNineStateProgressBadge();
    }
  } else if (badgeType === "CARB E.O. Not Required") {
    icon = getNotRequiredBadge();
  } else if (badgeType === "Emissions Compliance In Process") {
    icon = getInProcessBadge();
  }

  return `<div class="collection__product-eoline">
      <div class="icon comp-badge">
        ${icon}
      </div>
      <div class="comp-text">
        <h2 class="eo-title">${badgeType}<h2>
        <h3 class="eo-code">${badgeCode}<h3>
      </div>
    </div>`;
}

const reviewStar = `<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>`;
const reviewEmptyStar = `<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>`;
const reviewHalfStar = `<span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span>`;

const getReviewsDiv = (reviewData, reviewStarsSpan, productID) => {
  return `   
    <div class="product-card__reviews yotpo bottomLine" data-product-id="${productID}"> 
        <div class="yotpo-display-wrapper" aria-hidden="true" style="visibility: hidden;">
        <div class="standalone-bottomline" data-source="default"> 
            <div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">
                ${reviewStarsSpan}
                <span class="yotpo-review-count">(${reviewData.total_reviews})</span>                                
            </div> 
        </div>  
        </div>
    </div>
  `;
};

async function getReviewData(productId) {
  const resData = await fetch("https://w3g1867be0.execute-api.us-west-2.amazonaws.com/Prod/get-product-review-data", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ productId: productId }),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Fetch not successful");
      return response.json();
    })
    .then((data) => {
      return data.response.bottomline;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  return resData;
}

const renderCardReviews = async (cardID, productID) => {
  const priceDiv = $(cardID).find(".collection__product-price");

  // get reviews from yotpo
  let reviewData = await getReviewData(productID);

  let avgScore = reviewData.average_score;
  const scoreWhole = parseInt(avgScore);
  const scoreDecimal = avgScore - scoreWhole;

  let reviewStars = "";
  for (let i = 0; i < scoreWhole; i++) {
    reviewStars = reviewStars + reviewStar;
  }

  if (scoreDecimal > 0) {
    reviewStars = reviewStars + reviewHalfStar;
  }

  const remainingStars = parseInt(5 - avgScore);

  for (let i = 0; i < remainingStars; i++) {
    reviewStars = reviewStars + reviewEmptyStar;
  }

  let reviewStarsSpan = `<span class="yotpo-stars" id="${productID}-stars">${reviewStars}</span>`;
  const div = getReviewsDiv(reviewData, reviewStarsSpan, productID);

  $(priceDiv).append(div);
};

const renderProductCard = (product) => {
  let productGID = product.id.toString();
  product.id = productGID.split("Product/")[1] || product.id;
  let variantsList = [];
  let price = product.variants[0].price;
  let updatePrice = product.variants[0].compareAtPrice;
  for (let i = 0; i < product.variants.length; i++) {
    variantsList.push(product.variants[i].sku);
    if (product.variants[i].price < price) {
      price = product.variants[i].price;
      updatePrice = product.variants[i].compareAtPrice;
    }
  }

  let priceText;
  if (variantsList.length > 1) {
    priceText = `From $${price}`;
  } else {
    priceText = `$${price}`;
  }

  // yellow price banner
  let availability;
  if (!product.availabilityRemarks) {
    availability = `yes`;
    // availability = `${product.priceUpdateText}`;
    // availability = `${settings.product_price_update_text}`;
  } else {
    availability = `no`;
    // availability = `${product.availabilityremarks}`;
  }

  let compBadge;
  if (product.eoLine1) {
    compBadge = getComplianceBadge(product.eoLine1, product.eoLine2);
  }

  return `
      <div class="product-item__image-link borders">
          <div class="collection__product-item" data-product-id=${product.id}>
            <a href="https://bankspower.myshopify.com/products/${product.handle}">
              <div class="collection__product-image">
                  <img class="collection__product-image" src="${
                    product.image
                      ? product.image
                      : "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081"
                  }"/>
              </div>
            </a>
            <div class="collection__product-text">
              <a href="https://bankspower.myshopify.com/products/${product.handle}">
                <div class="collection__product-description">
                    <div class="product-sku">SKU # ${variantsList}                   
                    </div>

                    <div class="product-title">${product.title}</div>

                    ${
                      product.fitmentTitle ? ` <div class="product-key-feature"> ${product.shortDescription}</div>` : ""
                    }

                    ${
                      product.fitmentTitle ? `<div class="product-compatibility">For ${product.fitmentTitle}</div>` : ""
                    }

                    ${product.fitmentTitle ? `<div class="product-key-feature">${product.keyFeature}</div>` : ""}
        
                    ${
                      !product.isComingSoon && !!product.priceUpdateText
                        ? `
                          <div class="product-price-update-tag__container">
                            <div class="product-price-update-tag">
                              ${product.priceUpdateText}
                              ${availability}
                            </div>
                            <span class="product-price-update-tag__price" data-price-update>${updatePrice}</span>
                          </div>
                          `
                        : ""
                    }
                </div>

                <div class="collection__product-price">
                  <div class="product-price">
                    ${product.isComingSoon ? "Coming Soon" : priceText}                    
                  </div>
                </div>

                ${compBadge ?? ""}
              </a>

              <div class="collection-product__buttons-wrapper">
                <div class="collection-product__buttons">
                  <div class="collection-product__btn-wrapper">
                      <a href="https://bankspower.myshopify.com/products/${product.handle}">
                          <button class="btn btn--alternative">
                              <span>Learn more</span>
                          </button>
                      </a>
                  </div>
                  <div class="collection-product__btn-wrapper">
                    ${
                      isIDashProduct(product) && product.handle !== getIDashProduct()
                        ? `
                          <a href="#" data-idash-show-modal>
                            <button class="btn btn--primary">
                              <span>Choose Your iDash</span>
                            </button>
                          </a>
                        `
                        : product.variants.length > 1 || product.isComingSoon
                        ? `
                          <a href="https://bankspower.myshopify.com/products/${product.handle}">
                            <button class="btn btn--primary">
                              <span>${product.isComingSoon ? "View Product" : "Configure"}</span>
                            </button>
                          </a>
                          `
                        : `
                          <button 
                            data-quick-add-to-cart
                            id="product-${product.id}-add-to-cart" 
                            data-key-feature="${product.keyFeature == undefined ? "undefined" : product.keyFeature}"
                            data-key-fitment="${product.fitmentTitle == undefined ? "undefined" : product.fitmentTitle}"
                            type="button" 
                            class="btn btn--primary"
                            data-product-handle="${product.handle}"
                            onclick="quickAddToCartProduct(this)"
                          >
                            <span>Add to cart</span>
                            <div class="btn__loading-wrap">
                              <div class="btn__loading-bar"></div>
                            </div>
                          </button>
                         `
                    } 
                  </div>
                </div>
              </div>
            </div>
          </div> 
      </div>
    `;
};
